import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../ui/Button/Button';
import { TranslationKey } from '../../../i18n/translationKeys';
import type { TemplateLanguage } from '../../../types/customEmailTemplate';
import { MACROS, markerLabel } from './customTemplateMarkers';
import type { Macro } from './customTemplateMarkers';

interface MacroInsertButtonsProps {
    language: TemplateLanguage;
    onInsert: (macro: Macro) => void;
    disabled?: boolean;
}

export const MacroInsertButtons: React.FC<MacroInsertButtonsProps> = ({ language, onInsert, disabled = false }) => {
    const { t } = useTranslation();

    return (
        <div className="flex flex-wrap items-center gap-s">
            <span className="text-s text-content-secondary">{t(TranslationKey.CustomEmailTemplate.Modal.Insert)}</span>
            {MACROS.map(macro => {
                const label = markerLabel(macro, language);
                return (
                    <Button
                        key={macro}
                        type="button"
                        variant="secondary"
                        size="sm"
                        disabled={disabled}
                        // Keeps the caret in the field: a mousedown on the button would otherwise blur it first.
                        onMouseDown={e => e.preventDefault()}
                        onClick={() => onInsert(macro)}
                        aria-label={t(TranslationKey.CustomEmailTemplate.Modal.InsertAriaLabel, { label })}
                        data-testid={`custom-email-template-insert-${macro}`}
                    >
                        {label}
                    </Button>
                );
            })}
        </div>
    );
};
